  <div class="card shadow-lg rounded" [ngClass]="cardColor" id="popOverId"  style="padding: unset;" (click)="onmodelOpenClicked()">
    <div class="card-body align-items-center justify-content-end p-1" (click)="onmodelOpenTransactionVolume()">

      <div [ngClass]="count" class="mt-2 pt-2 d-flex mx-3">
        <div  placement="bottom" triggers="mouseenter:mouseleave" [ngbPopover]="label"  popoverClass="my-custom-class">
          <h5 >
            {{Volume}}
          </h5>
        </div>
        <div placement="bottom" triggers="mouseenter:mouseleave" [ngbPopover]="countlabel"  popoverClass="popovertext">
          <h5 
        (click)="onModelOpenTransactionCount($event)">{{Count}}
        </h5>
        </div>
        
      </div>

      <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1" [loaderId]="loaderId"
        [bgsPosition]="'center-center'">
      </ngx-ui-loader>

      <div class="mx-3 period">
        <p [ngClass]="text">{{TimePeriod}}</p>
      </div>

    </div>

    <div class="mb-2 d-flex justify-content-end icon" *ngIf = isShow >
      <div class="px-3" [ngClass]="cardButton" placement="left" triggers="mouseenter:mouseleave" popoverClass="popovertext"  [ngbPopover]="btnLabel" (click)="onNavigateClicked($event)">
          <i class="mdi mdi-arrow-collapse-down"></i>
      </div>
    </div>
</div>
